var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.40431L10.9156 3.22217V3.22662C10.5689 2.87107 10.0044 2.87107 9.65333 3.21773L0 12.8398V0.888875C0 0.399994 0.4 0 0.888889 0H15.1111C15.6 0 16 0.399994 16 0.888875V8.40431ZM1.23999 4.28882C1.23999 5.27103 2.03555 6.06657 3.01777 6.06657C3.99999 6.06657 4.79555 5.27103 4.79555 4.28882C4.79555 3.30662 3.99999 2.51107 3.01777 2.51107C2.03555 2.51107 1.23999 3.30662 1.23999 4.28882ZM0 15.1112V14.7201L9.64 5.10691C9.99111 4.76025 10.5556 4.76469 10.9022 5.1158L16 10.3068V15.1112C16 15.6001 15.6 16.0001 15.1111 16.0001H0.888889C0.4 16.0001 0 15.6001 0 15.1112Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSmall);
export default __webpack_public_path__ + "static/media/image-small.c3a82e1175157af313cf88a6338680f9.svg";
export { ForwardRef as ReactComponent };